/**
 * Port of {@class FieldType} —
 * backend/src/main/java/com/irian/iam/ruleengine/api/FieldType.java
 *
 * Closed enumeration of the value shapes a FieldDefinition can declare.
 */

import {FieldTypeTag} from './ast/FieldTypeTag'

export type FieldTypeInfo = {
    readonly name: string
    readonly wireName: string
    readonly shapeDescription: string
    readonly operatorTag: FieldTypeTag
}

export const FieldType = {
    STRING: {name: 'STRING', wireName: 'string', shapeDescription: 'text (string)', operatorTag: FieldTypeTag.SCALAR},
    ENUM: {name: 'ENUM', wireName: 'enum', shapeDescription: 'text (enum)', operatorTag: FieldTypeTag.ENUM},
    NUMBER: {name: 'NUMBER', wireName: 'number', shapeDescription: 'number', operatorTag: FieldTypeTag.NUMBER},
    BOOLEAN: {name: 'BOOLEAN', wireName: 'boolean', shapeDescription: 'boolean', operatorTag: FieldTypeTag.BOOLEAN},
    COLLECTION: {name: 'COLLECTION', wireName: 'collection', shapeDescription: 'collection', operatorTag: FieldTypeTag.COLLECTION},
    SCOPE: {name: 'SCOPE', wireName: 'scope', shapeDescription: 'scope (nested entity)', operatorTag: FieldTypeTag.ANY},
    DYNAMIC: {name: 'DYNAMIC', wireName: 'dynamic', shapeDescription: 'dynamic (attribute bag)', operatorTag: FieldTypeTag.ANY},
    DEFAULT: {name: 'DEFAULT', wireName: 'default', shapeDescription: 'row reference', operatorTag: FieldTypeTag.ANY},
} as const

export type FieldType = typeof FieldType[keyof typeof FieldType]

export function isCollection(ft: FieldType): boolean {
    return ft.name === FieldType.COLLECTION.name
}

export function isScope(ft: FieldType): boolean {
    return ft.name === FieldType.SCOPE.name
}

export function isDynamic(ft: FieldType): boolean {
    return ft.name === FieldType.DYNAMIC.name
}
